import { Typography, Tooltip, Icon } from "@plum-xoxo/admin-dsm";
import React from "react";
import theme from "../../../theme/theme";

const GrandTotalToolTip = ({
  currencyCode,
  totalInUserCurrency,
  totalHandlingCharge,
}) => {
  return (
    <Tooltip
      tooltip={
        <>
          <div className="d-flex justify-content-between">
            <Typography.HelperText>Item Subtotal:</Typography.HelperText>
            <Typography.HelperText>
              {currencyCode} {parseFloat(totalInUserCurrency).toFixed(2)}
            </Typography.HelperText>
          </div>
          <div className="d-flex justify-content-between mt-8">
            <Typography.HelperText>Handling Charges*:</Typography.HelperText>
            <Typography.HelperText>
              {currencyCode} {parseFloat(totalHandlingCharge).toFixed(2)}
            </Typography.HelperText>
          </div>
          <hr
            style={{
              borderTop: `1px solid ${theme.palette.light.c000}`,
            }}
            className="my-8"
          />
          <div className="d-flex justify-content-between mt-8">
            <Typography.HelperText>Total Payable:</Typography.HelperText>
            <Typography.HelperText>
              {currencyCode}{" "}
              {parseFloat(
                parseFloat(totalInUserCurrency) +
                  parseFloat(totalHandlingCharge)
              ).toFixed(2)}
            </Typography.HelperText>
          </div>
          <div className="mt-16">
            <Typography.HelperText>
              *Handling charges are calculated based on the product in the
              campaign with the highest charge.
            </Typography.HelperText>
          </div>
        </>
      }
      width={234}
    >
      <Icon className="ml-6 mb-1" iconName="Info" size={16} />
    </Tooltip>
  );
};

export default GrandTotalToolTip;
